// src/pages/CGU.js - Conditions Générales d'Utilisation
import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

function CGU() {
  return (
    <div className="legal-container">
      <div className="legal-card">
        <div className="legal-header">
          <h1>📜 Conditions Générales d'Utilisation</h1>
          <p className="legal-date">Dernière mise à jour : Juillet 2026</p>
        </div>

        <div className="legal-content">
          <section>
            <h2>1. Objet</h2>
            <p>
              Les présentes Conditions Générales d'Utilisation (CGU) régissent l'utilisation de la plateforme 
              FirstArabic, accessible à l'adresse <strong>www.firstarabic.com</strong>, qui met en relation 
              des élèves souhaitant apprendre l'arabe avec des professeurs qualifiés.
            </p>
          </section>

          <section>
            <h2>2. Définitions</h2>
            <ul>
              <li><strong>Plateforme</strong> : le site web FirstArabic et ses services associés</li>
              <li><strong>Utilisateur</strong> : toute personne utilisant la Plateforme</li>
              <li><strong>Élève</strong> : Utilisateur inscrit pour suivre des cours d'arabe</li>
              <li><strong>Professeur</strong> : Utilisateur inscrit pour dispenser des cours d'arabe</li>
              <li><strong>Cours</strong> : session d'enseignement en visioconférence</li>
            </ul>
          </section>

          <section>
            <h2>3. Inscription et Compte</h2>
            <h3>3.1 Conditions d'inscription</h3>
            <p>
              L'inscription est ouverte à toute personne physique âgée d'au moins 18 ans, ou mineure 
              avec l'autorisation de son représentant légal. L'Utilisateur s'engage à fournir des 
              informations exactes et à jour.
            </p>
            
            <h3>3.2 Sécurité du compte</h3>
            <p>
              L'Utilisateur est responsable de la confidentialité de ses identifiants de connexion. 
              Toute activité réalisée depuis son compte est présumée être de son fait.
            </p>
          </section>

          <section>
            <h2>4. Services proposés</h2>
            <h3>4.1 Pour les Élèves</h3>
            <ul>
              <li>Accès au catalogue de professeurs qualifiés</li>
              <li>Réservation de cours en ligne (30 ou 60 minutes)</li>
              <li>Système d'abonnement avec crédits hebdomadaires</li>
              <li>Cours en visioconférence sécurisée</li>
              <li>Évaluation des professeurs après chaque cours</li>
            </ul>

            <h3>4.2 Pour les Professeurs</h3>
            <ul>
              <li>Création d'un profil professionnel</li>
              <li>Gestion des disponibilités</li>
              <li>Réception des réservations</li>
              <li>Rémunération des cours dispensés</li>
            </ul>
          </section>

          <section>
            <h2>5. Tarifs et Paiement</h2>
            <h3>5.1 Abonnements</h3>
            <p>
              FirstArabic propose des formules d'abonnement permettant d'accéder aux cours. 
              Les tarifs sont indiqués en euros TTC sur la page d'abonnement.
            </p>

            <h3>5.2 Paiement</h3>
            <p>
              Les paiements sont sécurisés via Stripe. Les données bancaires ne sont jamais 
              stockées sur nos serveurs.
            </p>

            <h3>5.3 Rémunération des Professeurs</h3>
            <p>
              Les Professeurs sont rémunérés selon un tarif fixe par cours dispensé,
              défini dans leur contrat de collaboration. Les paiements sont effectués
              mensuellement par virement.
            </p>

            <h3>5.4 Reconduction de l'abonnement</h3>
            <p>
              Les abonnements sont conclus pour une durée d'un mois et sont reconduits
              tacitement chaque mois, par périodes successives d'un mois, jusqu'à résiliation
              par l'Élève. Chaque échéance mensuelle est prélevée automatiquement sur le moyen
              de paiement enregistré. L'Élève peut mettre fin à cette reconduction à tout moment
              (voir article 10), sans frais ni pénalité, la résiliation prenant effet à la fin
              de la période en cours déjà réglée.
            </p>

            <h3>5.5 Droit de rétractation</h3>
            <p>
              Conformément aux articles L221-18 et suivants du Code de la consommation, l'Élève
              consommateur dispose d'un délai de <strong>14 jours</strong> à compter de la
              souscription pour exercer son droit de rétractation, sans avoir à motiver sa
              décision. Pour l'exercer, il suffit d'adresser une demande claire par email à
              <a href="mailto:contact@firstarabic.com"> contact@firstarabic.com</a> avant
              l'expiration de ce délai.
            </p>
            <p>
              <strong>Exception (exécution immédiate du service) :</strong> en souscrivant et
              en réservant un cours avant la fin du délai de 14 jours, l'Élève demande
              expressément l'exécution immédiate du service et reconnaît que son droit de
              rétractation prend fin dès que le service a été pleinement exécuté. Si le service
              n'a été que partiellement exécuté au moment de la rétractation, l'Élève reste
              redevable du montant correspondant aux prestations déjà fournies (cours consommés).
            </p>
          </section>

          <section>
            <h2>6. Annulation et Remboursement</h2>
            <h3>6.1 Annulation par l'Élève</h3>
            <ul>
              <li>Plus de 24h avant le cours : remboursement intégral du crédit</li>
              <li>Moins de 24h avant le cours : crédit non remboursé</li>
            </ul>

            <h3>6.2 Annulation par le Professeur</h3>
            <p>
              En cas d'annulation par le Professeur, l'Élève est intégralement remboursé 
              (crédit restitué).
            </p>
          </section>

          <section>
            <h2>7. Comportement et Obligations</h2>
            <h3>7.1 Règles de conduite</h3>
            <p>Les Utilisateurs s'engagent à :</p>
            <ul>
              <li>Respecter les autres Utilisateurs</li>
              <li>Ne pas tenir de propos injurieux, discriminatoires ou illégaux</li>
              <li>Être ponctuel aux cours réservés</li>
              <li>Utiliser la Plateforme conformément à sa destination</li>
            </ul>

            <h3>7.2 Obligations des Professeurs</h3>
            <ul>
              <li>Dispenser des cours de qualité</li>
              <li>Respecter les horaires convenus</li>
              <li>Maintenir à jour leurs disponibilités</li>
              <li>Répondre aux demandes dans un délai raisonnable</li>
            </ul>
          </section>

          <section>
            <h2>8. Propriété Intellectuelle</h2>
            <p>
              L'ensemble des éléments de la Plateforme (logo, design, textes, fonctionnalités) 
              sont la propriété exclusive de FirstArabic. Toute reproduction sans autorisation 
              est interdite.
            </p>
          </section>

          <section>
            <h2>9. Limitation de Responsabilité</h2>
            <p>
              FirstArabic agit en tant qu'intermédiaire technique et ne peut être tenu responsable :
            </p>
            <ul>
              <li>De la qualité pédagogique des cours</li>
              <li>Des litiges entre Élèves et Professeurs</li>
              <li>Des problèmes techniques indépendants de sa volonté</li>
            </ul>
          </section>

          <section>
            <h2>10. Résiliation</h2>
            <h3>10.1 Résiliation de l'abonnement en ligne</h3>
            <p>
              Conformément à l'article L215-1-1 du Code de la consommation (résiliation en
              ligne), l'Élève ayant souscrit un abonnement en ligne peut le résilier à tout
              moment directement depuis son espace personnel, via la rubrique
              « Mon compte », en quelques clics. La résiliation prend effet à la fin de la
              période mensuelle en cours, déjà réglée : l'Élève conserve l'accès à ses cours
              et crédits jusqu'à cette date, et aucun nouveau prélèvement n'est effectué. Aucun
              engagement de durée n'est imposé.
            </p>
            <h3>10.2 Suppression du compte</h3>
            <p>
              L'Utilisateur peut supprimer son compte à tout moment depuis son espace personnel
              ou en contactant le support. FirstArabic se réserve le droit de suspendre ou
              supprimer un compte en cas de violation des présentes CGU.
            </p>
          </section>

          <section>
            <h2>11. Modification des CGU</h2>
            <p>
              FirstArabic se réserve le droit de modifier les présentes CGU. Les Utilisateurs 
              seront informés de toute modification substantielle par email ou notification 
              sur la Plateforme.
            </p>
          </section>

          <section>
            <h2>12. Droit Applicable</h2>
            <p>
              Les présentes CGU sont soumises au droit français. En cas de litige, les tribunaux 
              français seront seuls compétents.
            </p>
          </section>

          <section>
            <h2>13. Contact</h2>
            <p>
              Pour toute question relative aux présentes CGU, contactez-nous à : 
              <a href="mailto:contact@firstarabic.com">contact@firstarabic.com</a>
            </p>
          </section>
        </div>

        <div className="legal-footer">
          <Link to="/">← Retour à l'accueil</Link>
          <div className="legal-links">
            <Link to="/mentions-legales">Mentions légales</Link>
            <Link to="/confidentialite">Confidentialité</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CGU;
